import {Action} from '@ngrx/store';
import {
  ImageWithSource,
  RemoveFloorImageCompletePayload,
  SaveFloorPlanRequest,
  UploadFloorImageCompletePayload
} from '../models/floor-plan-editor-view';
import {ErrorPayload} from '../../afb-api/models/general';

export enum FloorPlanEditorViewActionTypes {
  SelectFloor = '[FloorPlanEditorView] Select Floor',
  DeselectFloor = '[FloorPlanEditorView] Deselect Floor',
  UploadFloorImage = '[FloorPlanEditorView] Upload Floor Image',
  UploadFloorImageComplete = '[FloorPlanEditorView] Upload Floor Image Complete',
  RemoveFloorImage = '[FloorPlanEditorView] Remove Floor Image',
  RemoveFloorImageComplete = '[FloorPlanEditorView] Remove Floor Image Complete',
  ResetFloorImage = '[FloorPlanEditorView] Reset Floor Image',
  ResetFloorImageChangeStatus = '[FloorPlanEditorView] Reset Floor Image Change Status',
  SaveFloorPlan = '[FloorPlanEditorView] Save Floor Plan',
  SaveFloorPlanSuccess = '[FloorPlanEditorView] Save Floor Plan Success',
  SaveFloorPlanFail = '[FloorPlanEditorView] Save Floor Plan Fail'
}

export class SelectFloor implements Action {
  readonly type = FloorPlanEditorViewActionTypes.SelectFloor;

  constructor(public payload: string) {
  }
}

export class DeselectFloor implements Action {
  readonly type = FloorPlanEditorViewActionTypes.DeselectFloor;
}

export class UploadFloorImage implements Action {
  readonly type = FloorPlanEditorViewActionTypes.UploadFloorImage;

  constructor(public payload: ImageWithSource) {
  }
}

export class UploadFloorImageComplete implements Action {
  readonly type = FloorPlanEditorViewActionTypes.UploadFloorImageComplete;

  constructor(public payload: UploadFloorImageCompletePayload) {
  }
}

export class RemoveFloorImage implements Action {
  readonly type = FloorPlanEditorViewActionTypes.RemoveFloorImage;
}

export class RemoveFloorImageComplete implements Action {
  readonly type = FloorPlanEditorViewActionTypes.RemoveFloorImageComplete;

  constructor(public payload: RemoveFloorImageCompletePayload) {
  }
}

export class ResetFloorImage implements Action {
  readonly type = FloorPlanEditorViewActionTypes.ResetFloorImage;
}

export class ResetFloorImageChangeStatus implements Action {
  readonly type = FloorPlanEditorViewActionTypes.ResetFloorImageChangeStatus;
}

export class SaveFloorPlan implements Action {
  readonly type = FloorPlanEditorViewActionTypes.SaveFloorPlan;

  constructor(public payload: SaveFloorPlanRequest) {
  }
}

export class SaveFloorPlanSuccess implements Action {
  readonly type = FloorPlanEditorViewActionTypes.SaveFloorPlanSuccess;
}

export class SaveFloorPlanFail implements Action {
  readonly type = FloorPlanEditorViewActionTypes.SaveFloorPlanFail;

  constructor(public payload: ErrorPayload) {
  }
}

export type FloorPlanEditorViewActions =
  | SelectFloor
  | DeselectFloor
  | UploadFloorImage
  | UploadFloorImageComplete
  | RemoveFloorImage
  | RemoveFloorImageComplete
  | ResetFloorImage
  | ResetFloorImageChangeStatus
  | SaveFloorPlan
  | SaveFloorPlanSuccess
  | SaveFloorPlanFail;
